import { render } from "./newsList2.vue?vue&type=template&id=b1e12348&scoped=true"
import script from "./newsList2.vue?vue&type=script&lang=js"
export * from "./newsList2.vue?vue&type=script&lang=js"

import "./newsList2.vue?vue&type=style&index=0&id=b1e12348&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1e12348"]])

export default __exports__